var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.879,
    height: 11.115,
    viewBox: "0 0 15.879 11.115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-cloud-upload-alt",
    "data-name": "Icon awesome-cloud-upload-alt",
    d: "M13.338,7.078a2.385,2.385,0,0,0-2.223-3.24,2.37,2.37,0,0,0-1.322.4A3.97,3.97,0,0,0,2.382,6.22c0,.067,0,.134,0,.2a3.574,3.574,0,0,0,1.186,6.945H12.7a3.176,3.176,0,0,0,.635-6.287ZM9.761,8.6H8.138V11.38a.4.4,0,0,1-.4.4H6.55a.4.4,0,0,1-.4-.4V8.6H4.53a.4.4,0,0,1-.28-.677L6.865,5.309a.4.4,0,0,1,.561,0l2.615,2.615a.4.4,0,0,1-.28.677Z",
    transform: "translate(0 -2.25)",
    fill: "#3f8cff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.68835fd516c8d1450ea87cda60083513.svg";
export { ForwardRef as ReactComponent };